<template>
  <div class="contact-list" v-if="displayContacts.length">
    <div v-for="(contact, idx) in displayContacts" :key="idx" class="contact-entry">
      <div class="contact-category">
        <template v-if="getHeading(contact.category || contact.type)">
          {{ getHeading(contact.category || contact.type).label }}{{ getHeading(contact.category || contact.type).value ? ':' : '' }}
          {{ getHeading(contact.category || contact.type).value }}
        </template>
        <template v-else>{{ contact.category || contact.type || 'Contact' }}</template>
      </div>
      <div class="contact-details">
        <span v-if="contact.name">{{ contact.name }}</span>
        <span v-for="(info, index) in contact.info" :key="index">
          <span v-if="contact.name || index" class="contact-separator" aria-hidden="true"> · </span>
          {{ formatInfo(info) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactList',
  props: ['contacts'],
  computed: {
    displayContacts() {
      const contacts = new Map();
      for (const contact of this.contacts || []) {
        const info = [...new Set(contact.info || [])].filter((item) => !/^\s*payor\s+id\s*:/i.test(item));
        if (!contact.name && contact.info?.length && !info.length) continue;
        const key = JSON.stringify([contact.name, contact.category, contact.type, info]);
        if (!contacts.has(key)) contacts.set(key, { ...contact, info });
      }
      return Array.from(contacts.values());
    },
  },
  methods: {
    formatInfo(info) {
      const phone = typeof info === 'string' && info.match(/^Phone \((\d{3})(\d{3})(\d{4})\)$/);
      return phone ? `(${phone[1]}) ${phone[2]}-${phone[3]}` : info;
    },
    getHeading(text) {
      if (typeof text !== 'string') return '';
      const match = text.match(/^\s*\[([^[\]\r\n]+)\][ \t]*(?::[ \t]*([\s\S]*))?\s*$/);
      return match && match[1].trim() ? { label: match[1].trim(), value: match[2] || '' } : '';
    },
  },
};
</script>

<style scoped>
.contact-list { margin: 0.75rem 0; font-size: 0.9rem; line-height: 1.4; color: #666; overflow-wrap: anywhere; }
.contact-entry + .contact-entry { margin-top: 0.5rem; }
.contact-category { font-weight: 600; margin-bottom: 0.125rem; }
.contact-details { white-space: pre-line; }
.contact-separator { color: #7a7a7a; }
</style>
